"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ChatButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _ChatButton = require("./ChatButton.styled");
var _excluded = ["isOpen", "onClick"];
var ChatButton = exports.ChatButton = function ChatButton(_ref) {
  var isOpen = _ref.isOpen,
    onClick = _ref.onClick,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Button = _ChatButton.ChatButtonV2;
  var text = '';
  if (!isOpen) {
    text = window.location.pathname.includes('broadcast') ? 'Speaker chat' : 'chat';
  }
  return /*#__PURE__*/_react["default"].createElement(Button, (0, _extends2["default"])({
    "data-dd-action-name": "Speaker Chat",
    "data-testid": "chat-button",
    iconOnly: !text,
    isOpen: true,
    onClick: onClick
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: isOpen ? _freeSolidSvgIcons.faTimes : _proSolidSvgIcons.faMessages
  }), text);
};
ChatButton.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  onClick: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ChatButton;